export enum ModuleEnum {
  GreetingHeader = "GreetingHeader",
  Logistics = "Logistics",
  Values = "Values",
  Schedule = "Schedule",
  Mission = "Mission",
  Time = "Time",
  Links = "Links",
  Location = "Location",
  Media = "Media",
  TeamPhoto = "TeamPhoto",
  CandidatePostInterviewFeedback = "CandidatePostInterviewFeedback",
  Chat = "Chat",
  InterviewScheduler = "InterviewScheduler",
  InterviewTeam = "InterviewTeam",
  RichText = "RichText",
  InterviewProcess = "InterviewProcess",
  Offer = "Offer",
  Assessment = "Assessment",
}

export const NonListableModules = [
  ModuleEnum.CandidatePostInterviewFeedback,
  ModuleEnum.Chat,
];

export const SingleUsePerStageModules = [
  ModuleEnum.GreetingHeader,
  ModuleEnum.Time,
  ModuleEnum.Schedule,
  ModuleEnum.Location,
  ModuleEnum.Mission,
  ModuleEnum.Values,
  ModuleEnum.InterviewTeam,
  ModuleEnum.InterviewScheduler,
  ModuleEnum.InterviewProcess,
];

export const TempFixedModulePositionEnum = Object.freeze({
  [ModuleEnum.InterviewProcess]: 0,
  [ModuleEnum.GreetingHeader]: 2,
  [ModuleEnum.Time]: 3,
  [ModuleEnum.Location]: 4,
  [ModuleEnum.Schedule]: 5,
  [ModuleEnum.RichText]: 6,
  [ModuleEnum.InterviewTeam]: 7,
  [ModuleEnum.InterviewScheduler]: 8,
  [ModuleEnum.Logistics]: 9,
  [ModuleEnum.Media]: 11,
  [ModuleEnum.TeamPhoto]: 12,
  [ModuleEnum.Mission]: 13,
  [ModuleEnum.Values]: 14,
  [ModuleEnum.Links]: 15,
  [ModuleEnum.Assessment]: 16,
  [ModuleEnum.Offer]: 17,
  [ModuleEnum.Chat]: 98,
  [ModuleEnum.CandidatePostInterviewFeedback]: 99,
});

export const FirstOrderablePosition = TempFixedModulePositionEnum.RichText;

export const ModuleDisplayTypeEnum = Object.freeze({
  GreetingHeader: "GreetingHeader",
  InfoChips: "InfoChips",
  InfoCards: "InfoCards",
  Values: "Values",
  RichText: "RichText",
  Schedule: "Schedule",
  Mission: "Mission",
  Time: "Time",
  Links: "Links",
  Location: "Location",
  Remote: "Remote",
  Media: "Media",
  TeamPhoto: "TeamPhoto",
  CandidatePostInterviewFeedback: "CandidatePostInterviewFeedback",
  Chat: "Chat",
  InterviewScheduler: "InterviewScheduler",
  InterviewTeam: "InterviewTeam",
  InterviewProcess: "InterviewProcess",
  Offer: "Offer",
  Assessment: "Assessment",
});

export enum EventModuleEnum {
  ProminentInstructions = "ProminentInstructions",
  CoderPad = "CoderPad",
  Zoom = "Zoom",
}
